import { motion } from 'framer-motion';
import SEO from '@/components/SEO';

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <SEO page="privacy" />
      {/* Hero */}
      <section className="pt-32 pb-12 bg-slate-900">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white uppercase mb-4">
              Privacy Policy
            </h1>
            <p className="text-slate-400">Last updated: January 2026</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-slate max-w-none">
            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4">Introduction</h2>
            <p className="text-slate-600 mb-6">
              Vulcan Recruitment ("we", "our", "us") is committed to protecting and respecting your privacy. This policy explains how we collect, use, and protect your personal information when you use our website and services.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Information We Collect</h2>
            <p className="text-slate-600 mb-4">We may collect the following types of personal information:</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
              <li>Contact details (name, email address, phone number, address)</li>
              <li>Employment history and qualifications</li>
              <li>Information provided in CVs or resumes</li>
              <li>Information provided through our website forms</li>
              <li>Communication records between you and our team</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">We use your personal information to:</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
              <li>Provide recruitment and employment services</li>
              <li>Match candidates with suitable job opportunities</li>
              <li>Communicate with you about potential roles</li>
              <li>Respond to enquiries and provide support</li>
              <li>Comply with legal obligations</li>
              <li>Improve our services and website</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Information Sharing</h2>
            <p className="text-slate-600 mb-6">
              We may share your personal information with prospective employers when you apply for a role or register your interest with us. We will always seek your consent before sharing your CV or application details with any third party. We do not sell your personal information to third parties.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Data Security</h2>
            <p className="text-slate-600 mb-6">
              We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over the internet is completely secure.
            </p>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Your Rights</h2>
            <p className="text-slate-600 mb-4">Under Australian privacy law, you have the right to:</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
              <li>Access your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with the Office of the Australian Information Commissioner</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-slate-900 uppercase mb-4 mt-10">Contact Us</h2>
            <p className="text-slate-600 mb-6">
              If you have any questions about this privacy policy or our data practices, please contact us at:
            </p>
            <div className="bg-slate-50 p-6 border border-slate-200">
              <p className="text-slate-700 font-semibold">Vulcan Recruitment</p>
              <p className="text-slate-600">Email: info@vulcanrecruitment.com</p>
              <p className="text-slate-600">Phone: +61 469 362 319</p>
              <p className="text-slate-600">Location: Thomastown, Victoria, Australia</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
